export const depositPaymentTypes = {
  jkos: { name: 'reservationList.paymentType.jkos.title', value: 'jkos', type: 'third-part' },
  newebpay: { name: 'reservationList.paymentType.newebpay.title', value: 'newebpay', type: 'third-part' },
  linepay: { name: 'reservationList.paymentType.linepay.title', value: 'linepay', type: 'third-part' },
  wallet: { name: 'reservationList.paymentType.wallet.title', value: 'wallet', type: 'wallet' },
  externalWallet: { name: 'reservationList.paymentType.externalWallet.title', value: 'externalWallet', type: 'wallet' },
  'offline-jkos': { name: 'reservationList.paymentType.offlineJkos.title', value: 'offline-jkos', type: 'offline' },
  'offline-newebpay': { name: 'reservationList.paymentType.offlineNewebpay.title', value: 'offline-newebpay', type: 'offline' },
  'offline-linepay': { name: 'reservationList.paymentType.offlineLinepay.title', value: 'offline-linepay', type: 'offline' },
  'offline-cash': { name: 'reservationList.paymentType.offlineCash.title', value: 'offline-cash', type: 'offline' },
  free: { name: 'reservationList.paymentType.free.title', value: 'free', type: 'free' },
  offline: { name: 'reservationList.paymentType.offline.title', value: 'offline', type: 'offline' },
}

export const staticDepositPaymentTypes = [
  { name: '現金（實體店）', value: 'offline-cash' },
  { name: '信用卡（實體店）', value: 'offline-newebpay' },
  { name: 'LINE Pay（實體店）', value: 'offline-linepay' },
  { name: '街口（實體店）', value: 'offline-jkos' },
]

export const depositStatusConfig = {
  unpaid: { name: 'reservationList.depositPaymentStatus.unpaid.title', value: 'unpaid', tag: 'warning' },
  paid: { name: 'reservationList.depositPaymentStatus.paid.title', value: 'paid', tag: 'action' },
  waitRefund: { name: 'reservationList.depositPaymentStatus.waitRefund.title', value: 'waitRefund', tag: 'warning' },
  refund: { name: 'reservationList.depositPaymentStatus.refund.title', value: 'refund', tag: 'info' },
  fail: { name: 'reservationList.depositPaymentStatus.fail.title', value: 'fail', tag: 'danger' },
  expire: { name: 'reservationList.depositPaymentStatus.expire.title', value: 'expire', tag: 'danger' },
  free: { name: 'reservationList.depositPaymentStatus.free.title', value: 'free', tag: 'action' },
}

export const manualRefundPaymentType = {
  wallet: { name: '儲值金', value: 'wallet' },
  externalWallet: { name: '會員餘額', value: 'externalWallet' },
  newebpay: { name: '藍新手動', value: 'newebpay_manual' },
  jkos: { name: '街口手動', value: 'jkos_manual' },
  linepay: { name: 'LINEPAY手動', value: 'linepay_manual' },
  pchomepay: { name: '支付連手動', value: 'pchomepay_manual' },
  offline: { name: '線下付款', value: 'offline' },
}
export const batchManualRefundPaymentType = {
  wallet: { name: '儲值金', value: 'wallet' },
  externalWallet: { name: '會員餘額', value: 'externalWallet' },
}

export const refundLinkConfig = {
  jkos: 'https://www.jkos.com/Merchant.Web/MerchantLogin/Login',
  newebpay: 'https://www.newebpay.com/main/login_center/single_login',
  linepay: 'https://pay.line.me/portal/tw/auth/login?isFooterConventionChanged=true',
}

export const paymentParamsMapping = {
  linepay: {
    linePayChannelId: 'linePayChannelId',
    linePayChannelSecretKey: 'linePayChannelSecretKey',
  },

  newebpay: {
    merchantId: 'newebpayMerchantId',
    hashKey: 'newebpayHashKey',
    hashIV: 'newebpayHashIV',

    newebpayMerchantId: 'merchantId',
    newebpayHashKey: 'hashKey',
    newebpayHashIV: 'hashIV',
  },

  jkos: {
    merchantId: 'jkosStoreId',
    apiKey: 'jkosApiKey',
    digest: 'jkosSercertKey',

    jkosStoreId: 'merchantId',
    jkosApiKey: 'apiKey',
    jkosSercertKey: 'digest',
  },

  atm: {
    atmBankCode: 'atmBankCode',
    atmBankName: 'atmBankName',
    atmBranchName: 'atmBranchName',
    atmAccountName: 'atmAccountName',
    atmAccountNumber: 'atmAccountNumber',
  },

  pchome: {
    pcHomePayAppID: 'pcHomePayAppID',
    pcHomePaySecret: 'pcHomePaySecret',
  },

}

export const configMapping = {
  enable: 'enable',
  // scas
  feeModel: 'paymentMode',
  feeModelServiceCountPrice: 'cash',
  feeModelTotalPriceRatio: 'percentege',
  //
  enableIgnoreMTag: '',
  enableSpecifyMTag: '',
  IgnoreMTags: 'memberExclude',
  SpecifyMTags: 'memberInclude',
  //
  enableSpecifyService: '',
  enableIgnoreService: '',
  SpecifyServices: '',
  IgnoreServices: '',
  //
  enableIgnoreServiceAttach: '',
  enableSpecifyServiceAttach: '',
  IgnoreServiceAttaches: '',
  SpecifyServiceAttaches: '',
  //
  enableSpecifyTimeRange: '',
  specifyTimeRangeEnd: '',
  specifyTimeRangeStart: '',
  //
  id: '',
  createdAt: '',
  updatedAt: '',
}
